// frontend/src/contexts/LeadContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import leadService from '../services/leadService';

// ============================================================
// FIX: Export LeadContext and LeadProvider properly
// ============================================================

const LeadContext = createContext();

export function LeadProvider({ children }) {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({});

  const loadLeads = async (newFilters = filters) => {
    setLoading(true);
    setError(null);
    try {
      console.log('📊 LeadContext: Loading leads with filters:', newFilters);
      const data = await leadService.getLeads(newFilters);
      console.log('📊 LeadContext: Leads loaded:', data);
      setLeads(Array.isArray(data) ? data : []);
      setFilters(newFilters);
    } catch (err) {
      console.error('❌ LeadContext: Failed to load leads:', err);
      setError(err.error || 'Failed to load leads');
      setLeads([]);
    } finally {
      setLoading(false);
    }
  };

  const addLead = async (leadData) => {
    try {
      const newLead = await leadService.createLead(leadData);
      setLeads([newLead, ...leads]);
      return newLead;
    } catch (err) {
      console.error('❌ LeadContext: Failed to add lead:', err);
      throw err;
    }
  };

  const updateLead = async (id, leadData) => {
    try {
      const updated = await leadService.updateLead(id, leadData);
      setLeads(leads.map(l => l.lead_id === id ? updated : l));
      return updated;
    } catch (err) {
      console.error('❌ LeadContext: Failed to update lead:', err);
      throw err;
    }
  };

  const deleteLead = async (id) => {
    try {
      await leadService.deleteLead(id);
      setLeads(leads.filter(l => l.lead_id !== id));
    } catch (err) {
      console.error('❌ LeadContext: Failed to delete lead:', err);
      throw err;
    }
  };

  // Initial load
  useEffect(() => {
    console.log('📊 LeadContext: Initializing - loading leads');
    loadLeads();
  }, []);

  return (
    <LeadContext.Provider value={{
      leads,
      loading,
      error,
      filters,
      loadLeads,
      addLead,
      updateLead,
      deleteLead
    }}>
      {children}
    </LeadContext.Provider>
  );
}

export function useLeads() {
  const context = useContext(LeadContext);
  if (!context) {
    throw new Error('useLeads must be used within a LeadProvider');
  }
  return context;
}

// ============================================================
// FIX: Also export default for backward compatibility
// ============================================================
export default { LeadProvider, useLeads };